import React from 'react';
import { Helmet } from 'react-helmet';
import AIheader from '../RentAI/AIheader';
import Footer from '../../Component/Footer/Footer';
import HeroSection from '../../Component/VipOnboarding/HeroSection';
import AboutSection from '../../Component/VipOnboarding/AboutSection';
import WhatsIncludedSection from '../../Component/VipOnboarding/WhatsIncludedSection';
import RentAISection from '../../Component/VipOnboarding/RentAISection';
import PricingCTASection from '../../Component/VipOnboarding/PricingCTASection';
import PricingSection from '../../Component/VipOnboarding/PricingSection';
import ProductSection from '../../Component/VipOnboarding/ProductSection';
import FooterSection from '../../Component/VipOnboarding/FooterSection';
import StickyMobileCTA from '../../Component/VipOnboarding/StickyMobileCTA';
import '../../Component/VipOnboarding/VipOnboarding.css';

// VIP Onboarding landing page. Uses the site-standard header (AIheader) and
// Footer; the page body is the ported VIP Onboarding content sections.
const VipOnboarding = () => (
  <>
    <Helmet>
      <title>VIP Onboarding | Rentid — The Rental Commerce Platform</title>
      <meta
        name="description"
        content="Schedule your VIP onboarding with Rentid. Get a one-on-one walkthrough of bookings, verification, insurance, automation, and rental workflows built for modern operators."
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
    </Helmet>

    <AIheader />

    <div className="vip-onboarding">
      <HeroSection />
      <AboutSection />
      <WhatsIncludedSection />
      <RentAISection />
      <PricingCTASection />
      <PricingSection />
      <ProductSection />
      <FooterSection />
      <StickyMobileCTA />
    </div>

    <Footer />
  </>
);

export default VipOnboarding;
